import styled from 'styled-components';
import { Flex } from '@chakra-ui/react';

export const Container = styled(Flex)`
  flex-direction: column;
  gap: 0.5rem;

  .css-78joka {
    border-color: ${({ theme }) => theme.colors.gray600};
  }

  span.chakra-radio__control[data-checked] {
    background-color: ${({ theme }) => theme.colors.white};
    border-color: ${({ theme }) => theme.colors.tertiary} !important;
    border: 1px solid;
    color: white !important;
    box-shadow: none;

    &:focus {
      border: none;
    }

    &::before {
      background-color: ${({ theme }) => theme.colors.tertiary};
      width: 65%;
      height: 65%;
    }
  }

  span.chakra-radio__label[data-checked] {
    color: ${({ theme }) => theme.colors.tertiary};
    font-weight: 700;
  }
`;
